var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h6", { staticClass: "font-weight-normal" }, [
      _vm._v(_vm._s(_vm.$t(`${_vm.configId}.upload.title`))),
    ]),
    _vm._v(" "),
    _c("hr", { staticClass: "mt-2" }),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-sm-4" },
        [
          _c(
            "MaterialSelect",
            {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'",
                },
              ],
              staticClass: "city-form-group city-bg",
              attrs: {
                disabled: _vm.disabled,
                id: "input-status",
                name: "status",
                label: "name",
                filterable: true,
                options: _vm.lists.onoff,
                reduce: (option) => option.code,
                "data-vv-scope": _vm.vScope,
                inputClasses: [
                  { "is-invalid": _vm.fnHasError("status", _vm.vScope) },
                ],
                error: _vm.fnFirstError("status", _vm.vScope),
                helpText: _vm.helpUpload.status,
              },
              model: {
                value: _vm.form.status,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.form,
                    "status",
                    typeof $$v === "string" ? $$v.trim() : $$v
                  )
                },
                expression: "form.status",
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t(`${_vm.configId}.upload.model.status`)) +
                  "\n            "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-4" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c(
              "MaterialInput",
              {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required: true,
                      integer: true,
                      min_value: _vm.minFeatures,
                    },
                    expression:
                      "{'required': true, 'integer': true, 'min_value': minFeatures}",
                  },
                ],
                staticClass: "city-form-group city-bg",
                attrs: {
                  readonly: _vm.disabled,
                  disabled: _vm.disabled,
                  type: "number",
                  id: "input-minfeatures",
                  name: "minfeatures",
                  "data-vv-scope": _vm.vScope,
                  inputClasses: [
                    { "is-invalid": _vm.fnHasError("minfeatures", _vm.vScope) },
                  ],
                  error: _vm.fnFirstError("minfeatures", _vm.vScope),
                  helpText: _vm.helpUpload.minfeatures,
                },
                model: {
                  value: _vm.form.minfeatures,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form,
                      "minfeatures",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "form.minfeatures",
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t(`${_vm.configId}.upload.model.minfeatures`)) +
                    "\n                "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-4" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c(
              "MaterialInput",
              {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required: true,
                      integer: true,
                      min_value: _vm.form.minfeatures,
                    },
                    expression:
                      "{'required': true, 'integer': true, 'min_value': form.minfeatures}",
                  },
                ],
                staticClass: "city-form-group city-bg",
                attrs: {
                  readonly: _vm.disabled,
                  disabled: _vm.disabled,
                  type: "number",
                  id: "input-maxfeatures",
                  name: "maxfeatures",
                  "data-vv-scope": _vm.vScope,
                  inputClasses: [
                    { "is-invalid": _vm.fnHasError("maxfeatures", _vm.vScope) },
                  ],
                  error: _vm.fnFirstError("maxfeatures", _vm.vScope),
                  helpText: _vm.helpUpload.maxfeatures,
                },
                model: {
                  value: _vm.form.maxfeatures,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form,
                      "maxfeatures",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "form.maxfeatures",
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.$t(`${_vm.configId}.upload.model.maxfeatures`)) +
                    "\n                "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-6" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c(
              "MaterialInput",
              {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: _vm.rulesUploadFilterName,
                    expression: "rulesUploadFilterName",
                  },
                ],
                staticClass: "city-form-group city-bg",
                attrs: {
                  readonly: _vm.disabled,
                  disabled: _vm.disabled,
                  type: "text",
                  id: "input-filterProperty",
                  name: "filterProperty",
                  "data-vv-scope": _vm.vScope,
                  inputClasses: [
                    {
                      "is-invalid": _vm.fnHasError(
                        "filterProperty",
                        _vm.vScope
                      ),
                    },
                  ],
                  error: _vm.fnFirstError("filterProperty", _vm.vScope),
                  helpText: _vm.helpUpload.filterProperty,
                },
                model: {
                  value: _vm.form.filterProperty,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form,
                      "filterProperty",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "form.filterProperty",
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$t(`${_vm.configId}.upload.model.filterProperty`)
                    ) +
                    "\n                "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-6" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c(
              "MaterialInput",
              {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: _vm.rulesUploadFilterProperty,
                    expression: "rulesUploadFilterProperty",
                  },
                ],
                staticClass: "city-form-group city-bg",
                attrs: {
                  readonly: _vm.disabled,
                  disabled: _vm.disabled,
                  type: "text",
                  id: "input-filterBoundary",
                  name: "filterBoundary",
                  "data-vv-scope": _vm.vScope,
                  inputClasses: [
                    {
                      "is-invalid": _vm.fnHasError(
                        "filterBoundary",
                        _vm.vScope
                      ),
                    },
                  ],
                  error: _vm.fnFirstError("filterBoundary", _vm.vScope),
                  helpText: _vm.helpUpload.filterGeneralBoundary,
                },
                model: {
                  value: _vm.form.filterBoundary,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form,
                      "filterBoundary",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "form.filterBoundary",
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$t(`${_vm.configId}.upload.model.filterBoundary`)
                    ) +
                    "\n                "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }